/**
 * Hội thoại ở mục "Doanh nghiệp chung" thì AI không tự trả lời (orchestrator
 * bỏ qua is_internal). Nhân viên bật "Tự động" rồi thấy AI im lặng mà không
 * hiểu vì sao — nói rõ ngay trên ô soạn tin và cho chuyển mục tại chỗ.
 */
import { toast } from 'sonner'
import { Building2, ArrowRightLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { apiError } from '@/lib/api-client'
import { useDatPhanLoai, type ConversationDetail } from '@/hooks/use-conversations'

export function ThanhAiNoiBo({ conv }: { conv: Pick<ConversationDetail, 'id' | 'isInternal' | 'aiMode'> }) {
  const dat = useDatPhanLoai()
  if (!conv.isInternal || conv.aiMode === 'manual') return null
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-xs">
      <Building2 className="h-4 w-4 shrink-0 text-primary" />
      <div className="min-w-0 flex-1">
        <span className="font-medium">Hội thoại đang ở mục Doanh nghiệp chung</span>
        <span className="block text-muted-foreground">
          AI không tự trả lời và báo cáo không tính hội thoại ở mục này, dù chế độ AI đang bật.
          Nếu đây là khách hàng, chuyển sang mục Khách hàng để AI hoạt động.
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-7 shrink-0"
        disabled={dat.isPending}
        onClick={() =>
          dat.mutate(
            { id: conv.id, phanLoai: 'khach_hang' },
            {
              onSuccess: () => toast.success('Đã chuyển sang mục Khách hàng — AI sẽ trả lời từ tin kế tiếp'),
              onError: (e) => toast.error(apiError(e)),
            },
          )
        }
      >
        <ArrowRightLeft className="h-3.5 w-3.5" /> Chuyển sang Khách hàng
      </Button>
    </div>
  )
}
